import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  HStack,
  Input,
  useToast,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import {
  addComment,
  getComments,
} from '../../stores/slices/comments/commentsActions';

const schema = yup
  .object({
    newComment: yup.string().required('This field is required'),
  })
  .required();

const AddComment = ({ commentType, commentListId }) => {
  const { userInfo } = useSelector(state => state.user);
  const dispatch = useDispatch();
  const toast = useToast();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSaveItem = async data => {
    await dispatch(
      addComment({
        ...data,
        commentType,
        commentListId,
        userId: userInfo.id,
      })
    );
    dispatch(
      getComments({
        commentType,
        commentListId,
      })
    );
    reset();
    toast({
      description: 'Comment has been added',
      colorScheme: 'primary',
      status: 'success',
      duration: 3000,
      isClosable: true,
      position: 'bottom-right',
      variant: 'primary',
    });
  };
  return (
    <Box w={'full'}>
      <form onSubmit={handleSubmit(onSaveItem)}>
        <HStack w={'full'} alignItems={'start'}>
          <FormControl isInvalid={errors.newComment}>
            <Input
              id="newComment"
              placeholder="Enter your comment here..."
              _placeholder={{ color: 'lightGray.500' }}
              {...register('newComment')}
            />
            <FormErrorMessage>
              {errors.newComment && errors.newComment.message}
            </FormErrorMessage>
          </FormControl>
          <Button type="submit" isLoading={isSubmitting}>
            Save
          </Button>
        </HStack>
      </form>
    </Box>
  );
};

export default AddComment;
